import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { Form, Input, Button, Typography, Space, Alert, Card } from 'antd';
import { MailOutlined, CheckCircleOutlined, ArrowLeftOutlined } from '@ant-design/icons';

const { Paragraph, Title } = Typography;

function ResetPasswordSetupScreen() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [resetMessage, setResetMessage] = useState("");

    useEffect(() => {
        document.title = t('resetPasswordSetup.pageTitle');
    }, [t]);

    const handleForgottenPassword = async (values) => {
        if (!values.email) {
            alert(t('resetPasswordSetup.emailRequired'));
            return;
        }

        try {
            setLoading(true);
            await axios.post(`/dotnet_api/v1/auth/forgotpassword`, {
                email: values.email,
                ClientURI: window.location.origin + "/user_reset_password"
            });
            setLoading(false);
            setResetMessage(t('resetPasswordSetup.linkSent'));
        } catch (err) {
            setLoading(false);
            alert(t('resetPasswordSetup.error'));
        }
    };

    return (
        <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                <Card style={{ borderRadius: 16 }} bodyStyle={{ padding: 32 }}>
                    <Title level={2} style={{ textAlign: 'center', marginBottom: 24 }}>
                        {t('resetPasswordSetup.title')}
                    </Title>
                    <Paragraph>
                        {t('resetPasswordSetup.instruction')}
                    </Paragraph>
                    {resetMessage && (
                        <Alert
                            message={resetMessage}
                            type="success"
                            showIcon
                            icon={<CheckCircleOutlined />}
                            style={{ marginBottom: 16 }}
                        />
                    )}
                    <Form
                        form={form}
                        name="resetPasswordSetup"
                        onFinish={handleForgottenPassword}
                        layout="vertical"
                    >
                        <Form.Item
                            name="email"
                            rules={[{ required: true, message: t('resetPasswordSetup.emailRequired') }]}
                        >
                            <Input 
                                prefix={<MailOutlined />} 
                                size="large"
                                placeholder={t('resetPasswordSetup.emailPlaceholder')} 
                            />
                        </Form.Item>
                        <Form.Item>
                            <Button 
                                type="primary" 
                                htmlType="submit" 
                                style={{ width: '100%' }} 
                                loading={loading}
                                size="large"
                            >
                                {loading ? t('resetPasswordSetup.sending') : t('resetPasswordSetup.sendLink')}
                            </Button>
                        </Form.Item>
                    </Form>
                    <Button 
                        icon={<ArrowLeftOutlined />} 
                        onClick={() => navigate(-1)()}
                        style={{ marginTop: 16 }}
                    >
                        {t('resetPasswordSetup.goBack')}
                    </Button>
                </Card>
            </Space>
    );
}

export default ResetPasswordSetupScreen;